export default __webpack_public_path__ + "static/media/AGB-logo-2017-WhiteWindow.9b687393.jpg";